import { render, staticRenderFns } from "./StatisticsQuestion.vue?vue&type=template&id=b401d3fe&scoped=true"
import script from "./StatisticsQuestion.vue?vue&type=script&lang=js"
export * from "./StatisticsQuestion.vue?vue&type=script&lang=js"
import style0 from "./StatisticsQuestion.vue?vue&type=style&index=0&id=b401d3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b401d3fe",
  null
  
)

export default component.exports